import React, { Component, Fragment } from "react";
import User_panel from "./user-panel";
import { Link } from "react-router-dom";
import { MENUITEMS } from "../../../constants/menu";
import { MENUITEMS_HR } from "../../../constants/menu4";
import { connect } from "react-redux";

import { change_Lang } from "../../../actions/Helper_action";
import { LogOut } from "../../../actions/Auth_action";
import {
  Get_List_Branches,
  Get_ToDo_Branch_To_Agent,
} from "../../../actions/Admin_action";
import { Get_List_Agents } from "../../../actions/Agent_action";
import {
  Get_List_All_Rent_Contracts,
  Get_List_All_Sell_Contracts,
  Get_List_Vella_Contracts,
} from "../../../actions/Invoice_action";
import { isMobile } from "react-device-detect";

export class sidebar extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;
    this.state = {
      selectedPath: "1",
      mainmenu:
        user.role === "RealEstate" || user.role === "Manager"
          ? MENUITEMS
          : MENUITEMS_HR,
      sidebar: true,
    };
  }
  componentDidMount() {
    if (window.innerWidth < 769) {
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
    } else {
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
    }
    var currentUrl = window.location.pathname;

    this.state.mainmenu.filter((items) => {
      if (!items.children) {
        if (items.path === currentUrl) this.setNavActive(items);
        return false;
      }
      items.children.filter((subItems) => {
        if (subItems.path === currentUrl) this.setNavActive(subItems);
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === currentUrl) this.setNavActive(subSubItems);
        });
      });
    });
  }

  setNavActive(item) {
    const { user } = this.props;
    if (user.role === "RealEstate" || user.role === "Manager") {
      MENUITEMS.filter((menuItem) => {
        if (menuItem != item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems != item) {
              submenuItems.active = false;
            }
            if (submenuItems.children) {
              submenuItems.children.map((childItem) => {
                childItem.active = false;
              });
              if (submenuItems.children.includes(item)) {
                submenuItems.active = true;
                menuItem.active = true;
              }
            }
          });
        }
      });
      item.active = !item.active;

      this.setState({
        mainmenu: MENUITEMS,
      });
    } else {
      MENUITEMS_HR.filter((menuItem) => {
        if (menuItem != item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems != item) {
              submenuItems.active = false;
            }
            if (submenuItems.children) {
              submenuItems.children.map((childItem) => {
                childItem.active = false;
              });
              if (submenuItems.children.includes(item)) {
                submenuItems.active = true;
                menuItem.active = true;
              }
            }
          });
        }
      });
      item.active = !item.active;

      this.setState({
        mainmenu: MENUITEMS_HR,
      });
    }
  }
  RemoveSidebar = () => {
    if (this.state.sidebar) {
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
      this.setState({ sidebar: false });
    } else {
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
      this.setState({ sidebar: true });
    }
  };

  render() {
    const { Change_Lang, user } = this.props;

    const mainmenu = this.state.mainmenu.map((menuItem, i) => (
      <li className={`${menuItem.active ? "active" : ""}`} key={i}>
        {menuItem.sidebartitle ? (
          <div className="sidebar-title">{menuItem.sidebartitle}</div>
        ) : (
          ""
        )}
        {menuItem.type === "sub" ? (
          <a
            className="sidebar-header "
            href="#!"
            onClick={() => {
              this.setNavActive(menuItem);
            }}
          >
            <menuItem.icon style={{ color: "#6972f0" }} />
            <span>{Change_Lang(menuItem.title)}</span>
            <i className="fa fa-angle-right pull-right"></i>
          </a>
        ) : (
          ""
        )}
        {menuItem.type === "logout" ? (
          <a
            className="sidebar-header -cursor-pointer"
            onClick={() => {
              this.setNavActive(menuItem);
              this.props.Logout();
            }}
          >
            <menuItem.icon />
            <span className="-cursor-pointer">
              {Change_Lang(menuItem.title)}
            </span>
          </a>
        ) : (
          ""
        )}
        {menuItem.type === "link" ? (
          <Link
            to={`${menuItem.path}`}
            className={`sidebar-header ${menuItem.active ? "active" : ""}`}
            onClick={() => this.setNavActive(menuItem)}
          >
            <menuItem.icon />
            <span>{Change_Lang(menuItem.title)}</span>
            {menuItem.children ? (
              <i className="fa fa-angle-right pull-right"></i>
            ) : (
              ""
            )}
          </Link>
        ) : (
          ""
        )}
        {menuItem.children ? (
          <ul
            className={`sidebar-submenu ${menuItem.active ? "menu-open" : ""}`}
            style={
              menuItem.active
                ? { opacity: 1, transition: "opacity 500ms ease-in" }
                : {}
            }
          >
            {menuItem.children.map((childrenItem, index) => (
              <li
                key={index}
                className={
                  childrenItem.children
                    ? childrenItem.active
                      ? "active"
                      : ""
                    : ""
                }
              >
                {childrenItem.type === "sub" ? (
                  <a
                    href="#!"
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang(childrenItem.title)}{" "}
                    <i className="fa fa-angle-right pull-right"></i>
                  </a>
                ) : (
                  ""
                )}

                {childrenItem.type === "link" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang(childrenItem.title)}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {childrenItem.type === "List Branches" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Branches();
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {this.props.Change_Lang("List Branches")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {childrenItem.type === "Agents_List" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Agents();
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Agents_List")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {this.props.list_branches.length >= 2 ? (
                  childrenItem.type === "Create Branch" ? (
                    <Link
                      to={`/dashboard`}
                      className={childrenItem.active ? "active" : ""}
                      onClick={() => {
                        this.setNavActive(childrenItem);
                        isMobile && this.RemoveSidebar();
                      }}
                    >
                      <i className="fa fa-circle"></i>
                      {Change_Lang("Create Branch")}
                    </Link>
                  ) : null
                ) : childrenItem.type === "Create Branch" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Create Branch")}
                  </Link>
                ) : null}

                {childrenItem.type === "Sent To Do" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_ToDo_Branch_To_Agent();
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Sent To Do")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {childrenItem.type === "Rent Contracts" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_All_Rent_Contracts();
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Rent Contracts")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {childrenItem.type === "Sell Contracts" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_All_Sell_Contracts();
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Sell Contracts")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {/* walas */}
                {childrenItem.type === "Vella Contracts" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Get_List_Vella_Contracts();
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("Vella Contracts")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {childrenItem.type === "logout_sub" ? (
                  <Link
                    to={`${childrenItem.path}`}
                    className={childrenItem.active ? "active" : ""}
                    onClick={() => {
                      this.setNavActive(childrenItem);
                      this.props.Logout();
                      isMobile && this.RemoveSidebar();
                    }}
                  >
                    <i className="fa fa-circle"></i>
                    {Change_Lang("s_logout")}{" "}
                  </Link>
                ) : (
                  ""
                )}
                {childrenItem.children ? (
                  <ul
                    className={`sidebar-submenu ${
                      childrenItem.active ? "menu-open" : "active"
                    }`}
                  >
                    {childrenItem.children.map((childrenSubItem, key) => (
                      <li
                        className={childrenSubItem.active ? "active" : ""}
                        key={key}
                      >
                        {childrenSubItem.type === "link" ? (
                          <Link
                            to={`${childrenSubItem.path}`}
                            className={childrenSubItem.active ? "active" : ""}
                            onClick={() => this.setNavActive(childrenSubItem)}
                          >
                            <i className="fa fa-circle"></i>
                            {Change_Lang(childrenSubItem.title)}
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </li>
            ))}
          </ul>
        ) : (
          ""
        )}
      </li>
    ));
    return (
      <Fragment>
        <div
          className={`${
            this.props.lang === "en" ? "page-sidebar" : "page-sidebar fk"
          }`}
        >
          <div className="main-header-left d-none d-lg-block">
            <div className="logo-wrapper justify-content-center mt-1">
              <Link to={`/dashboard`}>
                <i
                  className="mr-1"
                  style={{ color: "#4064d7", fontFamily: "cursive" }}
                >
                  {`${user.fname}  ${user.lname}`}
                </i>
              </Link>
            </div>
          </div>
          <div className="sidebar custom-scrollbar">
            <User_panel />
            <ul className="sidebar-menu">{mainmenu}</ul>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    role: state.AuthReducer.user.role,
    list_branches: state.AdminReducer.list_branches,
    user: state.AuthReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    Change_Lang: (key) => dispatch(change_Lang(key)),
    Logout: () => dispatch(LogOut()),
    Get_List_Branches: () => dispatch(Get_List_Branches()),
    Get_List_Agents: () => dispatch(Get_List_Agents()),
    Get_ToDo_Branch_To_Agent: () => dispatch(Get_ToDo_Branch_To_Agent()),
    Get_List_All_Rent_Contracts: () => dispatch(Get_List_All_Rent_Contracts()),
    Get_List_All_Sell_Contracts: () => dispatch(Get_List_All_Sell_Contracts()),
    Get_List_Vella_Contracts: () => dispatch(Get_List_Vella_Contracts()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(sidebar);
